module.exports = __webpack_public_path__ + "img/TelasIcarai.9247c051.png";